import { useState } from "react";
import { InputComponent } from "../../Utils/UI/InputComponent/InputComponent";
import { StepAccordion, AccordionMinimumHeight, ButtonColorEnum, AccordionBackgroundColor } from "../../Utils/StepAccordion";
import Column from "../../Utils/Column/Column";

interface IInputStepInterface {
	checkVoucherValidation(input: string): void;
	toggleOpenState(): void;
	open: boolean;
	loading: boolean;
}

const InputStep = ({
	checkVoucherValidation,
	toggleOpenState,
	open,
	loading,
}: IInputStepInterface) => {
	const [input, setInput] = useState("");

	return (
		<div className="input-step">
			<StepAccordion
				loading={loading}
				loadingText="Tjekker rabatkode"
				loadingTitle="Vent venligst"
				label="Indtast rabatkode"
				open={open}
				click={toggleOpenState}
				secondButtonLabel={"VALIDER KODE"}
				secondButtonType={ButtonColorEnum.DARK_GREEN}
				secondButton={() => checkVoucherValidation(input)}
				minimumHeight={AccordionMinimumHeight.EXTRASMALL}
				secondButtonId="checkVoucherValidation"
				secondButtonShadow={true}
				secondButtonDisabled={input.length === 0}
				backgroundColor={AccordionBackgroundColor.GREY}
			>
				<Column fullWidth={true}>
					<InputComponent
						placeholder="Rabatkode"
						validationType={"none"}
						change={(e): any => setInput(e.value)}
					/>
				</Column>
			</StepAccordion>
		</div>
	);
};

export default InputStep;
